import React from 'react'
import Heading from '../../components/Heading'
import BlogCard from '../../components/Blog-Card'
import BlogCardList from '../../components/Blog-Card/List'
import styles from './styles.module.scss'
import spaceStyles from '../../styles/space.module.scss'
import clsx from 'clsx'
import { addQueryParamsToUrl } from "../../util/imageUrlUtil"
import { sitecoreApiHost } from '../../temp/config'
import { Placeholder } from '@sitecore-jss/sitecore-jss-react'
import { RelatedTag } from './types'
import RelatedTopics from '../../components/RelatedTopics'
import Section from '../../components/Section/Section'
import getRandomGuid from '../../util/getRandomGuid'


type TagResultCardProps = {
  description: string
  href: string
  image: string
  imageAlt: string
  tag: string
  title: string
}

type TagResultsProps = {
  tagName: string
  tagPath: string
  cards: TagResultCardProps[]
  pagination: React.ReactNode
  contact: React.ReactNode
  isBlog: boolean
  relatedTags: RelatedTag[]
  ctaBanner: React.ReactNode
  routeData: any
}

function TagResults({
  tagName,
  cards,
  pagination,
  ctaBanner,
  routeData,
  relatedTags
}: TagResultsProps) {
  const divider = <div className={styles.divider}></div>
  const styleOverride = {
    link: styles.purpleText
  }

  const placeholder1 = 
    <div className="removeFirstMargin" style={{ width: '100%' }} key={"p1-" + getRandomGuid()}>
      <Placeholder name="Tag-Results-Middle-1" rendering={routeData}/>
    </div>
  const placeholder2 = 
    <div className="removeFirstMargin" style={{ width: '100%' }} key={"p2-" + getRandomGuid()}>
      <Placeholder name="Tag-Results-Middle-2" rendering={routeData}/>
    </div>

  const relatedTagsComponent = (
    <div className={styles.relatedTopics}>
    <Section backgroundColor="#F6F4FF">
      <RelatedTopics
        fields={{
          tags: relatedTags.map((tag: RelatedTag) => ({
            label: tag.friendlyName,
            href: tag.tagName
          })),
          title: "Related Topics",
          fallback: false
        }}
      />
    </Section> 
    </div>
  )


  const renderResults = () => {
    const renderedCards: React.ReactNode[] = []

    cards.forEach((card, index) => {
      renderedCards.push(
        <BlogCard
          key={card.href}
          title={card.title}
          href={card.href}
          image={addQueryParamsToUrl(sitecoreApiHost + card.image, `mh=220`)}
          imageAlt={card.imageAlt}
          imageWidth={350}
          imageHeight={220}
          horizontal
          feature={false}
          styleOverride={styleOverride}
        >
          {card.description ? card.description : false}
        </BlogCard>
      )

      // If this is the 4th card (index 3), inject the first placeholder.
      if (index === 3) { renderedCards.push(placeholder1) }
      // If this is the 8th card (index 7), inject the second placeholder.
      if (index === 7) { renderedCards.push(placeholder2) }
    })

    return (
      <div className={styles.body}>
        <BlogCardList fullWidth>
          {renderedCards}
        </BlogCardList>
        {pagination}
        {divider}
      </div>
    )
  }

  const renderNoResults = () => (
    <div className={styles.noResults}>
      <span className={styles.noResultsText}>
        Sorry, no tags match this search
      </span>
    </div>
  )

  const body = cards && cards.length ? renderResults() : renderNoResults()

  const h1Tag = { fields: { tag: { value: 'h1' } } }

  const heading = (
    <Heading
      testId={'TagResultsPage-Heading'}
      fields={{
        title: { value: tagName },
        tag: h1Tag,
      }}
      embed
    />
  )

  return (
    <div className="copy-article tag-results-article">
      <div className={clsx('block', spaceStyles.contain, styles.article)}>
        {heading}
        {body}
      </div>
      {relatedTagsComponent}
      {ctaBanner}
    </div>
  )
}

export default TagResults;
